import { Component } from '@angular/core';

import { NavController } from 'ionic-angular';
import CryptoJS from 'crypto-js';
//import { SignupPage } from '../signup/signup';
import { UserData } from '../../providers/user-data';
import { PPListPage } from '../pp-list/pp-list';


@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  login: {username?: string, password?: string} = {};
  submitted = false;

  constructor(public navCtrl: NavController, public userData: UserData) { }

  onLogin(form) {
    this.submitted = true;

    if (form.valid) {
      /*this.userData.login(this.login.username, this.login.password).then(data => {
        console.log(data);
      });*/
      let hash = CryptoJS.SHA512(this.login.password);     
      this.userData.login(this.login.username, hash.toString());
      
      //this.navCtrl.push(PPListPage);
    }
  }

  onSignup() {
    //this.navCtrl.push(SignupPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts